/**
 * Content Preprocessor
 * 
 * Main content preprocessing that combines citation and follow-up question processing
 * Based on the legacy implementation patterns
 */

import { processCitations } from './citationProcessor';
import { processFollowUpQuestions } from './followUpProcessor';
import type { ProcessedContent } from '../types';

export function preprocessContent(content: string): ProcessedContent {
  // First process follow-up questions
  const { content: contentWithQuestions, questions } = processFollowUpQuestions(content);
  
  // Then process citations
  const { content: finalContent, citations } = processCitations(contentWithQuestions);
  
  return {
    content: finalContent,
    citations,
    questions
  };
}